<div class="card-base">
    <div class="card-content-search">
        <div class="chip-container">
            <mat-chip-list>
                <mat-chip color="accent" matTooltip="{{filt.toolTip}}" selected *ngFor="let filt of searchFilters">
                    {{ filt.valueView }}
                    <mat-icon *ngIf="!filt.isRequired" (click)="filt.remove()">cancel</mat-icon>
                </mat-chip>
            </mat-chip-list>
        </div>
        <div class="card-container mat-elevation-z1">
            <div class="clearfix">
                <div class="pull-right div-header-right">

                    <button style="margin-right: 10px;" *ngIf="!loadingMasiveAction && isSomeSelected()" class="card-inline margin-top-medium" [matMenuTriggerFor]="menuItem" type="button" mat-mini-fab>
                        <mat-icon>more_vert</mat-icon>
                    </button>

                    <mat-spinner [diameter]="50" *ngIf="loadingMasiveAction"></mat-spinner>
                    <mat-menu #menuItem="matMenu">
                        <button (click)="assignToProfessional()" mat-menu-item>
                             <span> <b>Asignar a profesional</b></span>
                        </button>
                    </mat-menu>

                    <button matTooltip="Nueva plantilla" (click)="addNew()" type="button" mat-mini-fab>
                        <mat-icon>add</mat-icon>
                        </button>
                </div>
                <div class="pull-left div-header-left">
                    <app-search-filter-component #searchFilter (startSearch)="onStartSearch()" (endSearch)="onEndSearch($event)" [filter]="filters"></app-search-filter-component>
                    <app-study-report-template-filter #filters></app-study-report-template-filter>
                </div>
            </div>
            <mat-divider></mat-divider>
            <div class="card-content margin-botton-medium">
                <p-scrollPanel styleClass="scroll-panel">
                    <table class="search-table" mat-table [dataSource]="dataSource">

                        <ng-container matColumnDef="Select">
                            <th class="checkbox-column" mat-header-cell *matHeaderCellDef>
                                <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
                                </mat-checkbox>
                            </th>
                            <td class="checkbox-column" mat-cell *matCellDef="let row">
                                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
                                </mat-checkbox>
                            </td>
                        </ng-container>


                        <ng-container matColumnDef="Name">
                            <th mat-header-cell class="table-header" *matHeaderCellDef> Nombre</th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <div><b>{{element.Name}}</b></div>
                            </td>
                        </ng-container>


                        <!-- Star Column -->
                        <ng-container matColumnDef="Star" stickyEnd>
                            <th class="search-table-header" mat-header-cell *matHeaderCellDef></th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <button mat-icon-button [matMenuTriggerFor]="menuItem">
                  <mat-icon>more_vert</mat-icon>
                </button>
                                <mat-menu #menuItem="matMenu">
                                    <button mat-menu-item *ngIf="!loadingAction && !element.Deleted" (click)="edit(element)"><mat-icon>edit</mat-icon><span>Editar</span></button>
                                    <button mat-menu-item *ngIf="!loadingAction && !element.Deleted" (click)="delete(element)"><mat-icon>delete</mat-icon><span>Deshabilitar</span></button>
                                    <button mat-menu-item *ngIf="!loadingAction && element.Deleted" (click)="enable(element)"><mat-icon>redo</mat-icon><span>Habilitar</span></button>
                                </mat-menu>
                            </td>
                        </ng-container>
                        <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row class="search-table-cell" *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </p-scrollPanel>
                <pager (selectedPageIndexChange)="selectedPageIndexChange($event)" #pager></pager>
            </div>
        </div>
    </div>
</div>
